import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DocumentModal from '../../components/Modal/DocumentModal';
import { useApi } from '../../hooks/use-api';
import * as ROUTES from '../../constants/routes';
import DeleteDocumentModal from '../../components/Modal/DeleteDocumentModal';
import RightHeaderButton from '../../components/Tables/Components/RightHeaderButton';
import { useUser } from '../../hooks/use-user';
import DocumentsOverview from '../../components/Tables/EmployeeDetails/Documents/DocumentsOverview';

function Documents({ employeeId }) {
	const { t } = useTranslation();
	const { isSchoolAdmin, isSchoolSuperUser } = useUser();

	const [showEditModal, setEditModal] = useState(false);
	const [showDeleteModal, setDeleteModal] = useState(false);
	const [selectedDocument, setSelectedDocument] = useState(null);

	const [{ data: documents, isLoading: loadingDocuments }, fetchEmployeeDocuments] = useApi.get(
		ROUTES.getDocumentsForStudent(employeeId),
	);

	const handleDelete = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setEditModal(false);
		setDeleteModal(true);
	};

	const headerRight = () =>
		isSchoolAdmin || isSchoolSuperUser ? null : (
			<RightHeaderButton
				title={t('documents.add')}
				icon="glyphicons-file-plus"
				onClick={() => {
					setSelectedDocument(null);
					setEditModal(true);
				}}
			/>
		);

	return (
		<>
			<DeleteDocumentModal
				show={showDeleteModal}
				setShow={(show) => {
					setSelectedDocument(null);
					setDeleteModal(show);
				}}
				documentId={selectedDocument?.id}
				title={t('documents.delete')}
				message={t('documents.confirm_delete', { name: selectedDocument?.name })}
				successMessage={t('documents.deleted', { name: selectedDocument?.name })}
				handleSubmit={fetchEmployeeDocuments}
			/>
			<DocumentModal
				show={showEditModal}
				setShow={() => setEditModal(false)}
				selectedEntity={selectedDocument}
				handleSubmit={fetchEmployeeDocuments}
				studentId={employeeId}
				handleDelete={handleDelete}
			/>
			<div className="d-flex justify-content-end">{headerRight()}</div>
			{!loadingDocuments && (
				<DocumentsOverview
					documents={documents}
					handleRowClick={(original) => {
						setSelectedDocument(original);
						setEditModal(true);
					}}
				/>
			)}
		</>
	);
}

export default Documents;
